import React,{useEffect,useContext} from 'react';
import {useParams,useHistory} from "react-router-dom";
import config from '../config.json';
import {tenantContext} from '../context.js';
import {LoadingPage} from './LoadingPage.js';

export const TenantHandler = () => {
  // eslint-disable-next-line
  let {tenant_name} = useParams();
  // eslint-disable-next-line
  const [tenant,setTenant] = useContext(tenantContext);
  let history = useHistory();
  useEffect(()=>{
    if(config.host[tenant_name]){
      getTenant(tenant_name);  
    }
    else{
      setTenant(null);
      history.push('/404');
    }
    
    // eslint-disable-next-line
  },[]);

  const getTenant = (tenant_name)=>{

    fetch(config.host[tenant_name]+'tenants/'+tenant_name,{
      method:'GET',
      credentials:'include',
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if(response.status===200){
        return response.json();
      }
      else {
        return false
      }
    }).then(response=>{
      if(response&&response.base_url===window.location.protocol +"//"+ window.location.hostname +(window.location.port?(":"+window.location.port):"") +(config.basename==="/"?"/":config.basename + "/") + tenant_name ){
          setTenant(response);
        }
      else{
        setTenant(null);
        history.push('/404');
      }
    });
  }
  return (
    <React.Fragment>
      <LoadingPage loading={true}/>
    </React.Fragment>
  )
}

export const PageNotFound = (props) => {
  return (

      <div className="not_found_container">
        <h1><b>404</b>. That's an error.</h1>
        <h3>The requested url was not found on this server. <span>That's all we know.</span></h3>
      </div>

  )
}
